import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { createRoute, CreateRoute } from '~/generated';
import { extractData } from '~/utils/query-utils';

export type CustomRouteParam = Omit<CreateRoute, 'meetingPlace'> & {
  meetingPlace?: string | null;
};

export const useCreateRoute = (
  options?: UseMutationOptions<
    { id: number },
    unknown,
    CustomRouteParam,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values: CustomRouteParam) => {
      const response = await extractData(
        createRoute({
          body: {
            ...values,
            meetingPlace: values.meetingPlace ?? undefined,
          } as CreateRoute,
        })
      );
      return { id: response.route?.id ?? 0 };
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['routes'],
      });
      options?.onSuccess?.(...args);
    },
  });
};
